export default __webpack_public_path__ + "static/media/imagem-grande-tela-parceiros.1e14aa2c.png";